import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// TERM LOAN VERIFICATION
// Legacy: /AccountsApproval/VerifyTermLoan (+ VerifyTermLoanGrid / VerifyTermLoanView)
// ==============================================

const headers = { 'Content-Type': 'application/json' };

const handle = (error) => {
    if (error.response?.data) throw error.response.data;
    throw error;
};

// Queue — term loans pending at this role's level (spGettermloangrid; rows carry MOID and full details).
export const getVerificationTermLoans = async (roleId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GetVerificationtlDetails`, { params: { Roleid: roleId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Detail of one term loan (one-row list, same SP by row id).
export const getTermLoanById = async (rowId) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Accounts/GettlverificationbyId`, { params: { Rowid: rowId }, headers });
        return response.data;
    } catch (error) { return handle(error); }
};

// Verify / Approve / Return / Reject (spVerifyTermloan — success literal "Submitted").
export const verifyTermLoan = async (payload) => {
    try {
        const response = await axios.put(`${API_BASE_URL}/Accounts/Verifytermloan`, payload, { headers });
        return response.data;
    } catch (error) { return handle(error); }
};
